import { takeEvery, call, put, select } from 'typed-redux-saga'
import { errorHandler, notifyMessageCreator } from 'Modules'
import { Deserialize } from 'cerialize'
import { ResponseCatalog } from 'Models'
import {
	BlockingRulesModel,
	BlockingRulesNS,
	blockingRulesSlice,
	blockingRulesSelector,
	blockingRulesApi,
} from 'Pages/orders'

function* getAll(action: BlockingRulesNS.GetAll) {
	try {
		const { params } = action.payload
		const res = yield* call(blockingRulesApi.getAll, params)
		const entries = res.entries.map(
			(blockingRule): BlockingRulesModel => Deserialize(blockingRule, BlockingRulesModel)
		)
		const blockingRules = Deserialize(res, ResponseCatalog)
		blockingRules.entries = entries
		yield* put(blockingRulesSlice.actions.setAll(blockingRules))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* createOne(action: BlockingRulesNS.CreateOne) {
	try {
		yield* call(blockingRulesApi.createOne, action.payload)
		const requestParams = yield* select(blockingRulesSelector.getParams)
		const res = yield* call(blockingRulesApi.getAll, requestParams)
		const entries = res.entries.map(
			(blockingRule): BlockingRulesModel => Deserialize(blockingRule, BlockingRulesModel)
		)
		const blockingRules = Deserialize(res, ResponseCatalog)
		blockingRules.entries = entries
		yield* put(blockingRulesSlice.actions.setAll(blockingRules))
		yield* call(notifyMessageCreator, 'orders.create_blocking_rule.success', {
			data: [action.payload.name],
		})
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* updateOne(action: BlockingRulesNS.UpdateOne) {
	try {
		const { id, data } = action.payload
		yield* call(blockingRulesApi.updateOne, id, data)
		const requestParams = yield* select(blockingRulesSelector.getParams)
		const res = yield* call(blockingRulesApi.getAll, requestParams)
		const entries = res.entries.map(
			(blockingRule): BlockingRulesModel => Deserialize(blockingRule, BlockingRulesModel)
		)
		const blockingRules = Deserialize(res, ResponseCatalog)
		blockingRules.entries = entries
		yield* put(blockingRulesSlice.actions.setAll(blockingRules))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* deleteOne(action: BlockingRulesNS.DeleteOne) {
	try {
		yield* call(blockingRulesApi.deleteOne, action.payload)
		const requestParams = yield* select(blockingRulesSelector.getParams)
		const res = yield* call(blockingRulesApi.getAll, requestParams)
		const entries = res.entries.map(
			(blockingRule): BlockingRulesModel => Deserialize(blockingRule, BlockingRulesModel)
		)
		const blockingRules = Deserialize(res, ResponseCatalog)
		blockingRules.entries = entries
		yield* put(blockingRulesSlice.actions.setAll(blockingRules))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

export const blockingRulesSaga = function* saga() {
	yield* takeEvery(blockingRulesSlice.actions.getAll.type, getAll)
	yield* takeEvery(blockingRulesSlice.actions.createOne.type, createOne)
	yield* takeEvery(blockingRulesSlice.actions.deleteOne.type, deleteOne)
	yield* takeEvery(blockingRulesSlice.actions.updateOne.type, updateOne)
}
